import React from "react";
import { Table, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";

const PermissionTable = ({ permissions, actionList, roleList }) => (
  <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Action</Table.HeaderCell>
        {roleList.map((role) => (
          <Table.HeaderCell key={role}>
            {role.replace(/_/g, " ")}
          </Table.HeaderCell>
        ))}
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {actionList.map((action) => (
        <Table.Row key={action}>
          <Table.Cell>{action.replace(/_/g, " ")}</Table.Cell>
          {roleList.map((role) => (
            <Table.Cell key={role}>
              {permissions[role][action] ? (
                <Icon name="check" color="green" />
              ) : (
                <Icon name="close" color="red" />
              )}
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

PermissionTable.propTypes = {
  permissions: PropTypes.object.isRequired,
  actionList: PropTypes.array.isRequired,
  roleList: PropTypes.array.isRequired,
};

export default PermissionTable;
